var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('span',{staticClass:"i-layout-header-trigger",class:{ 'i-layout-header-trigger-min': _vm.showReload },on:{"click":_vm.handleToggleMenuSide}},[_c('Icon',{attrs:{"custom":`i-icon i-icon-menu-${_vm.menuCollapse ? 'unfold' : 'fold'}`}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }